import { z } from "zod";
import { customFieldValueSchema } from "./custom-field-value.schemas.js";

export const eventParticipantProfileSchema = z.object({
  hostLabels: z.array(z.string()).readonly(),
  customFields: z.record(z.string(), customFieldValueSchema).nullable(),
});

export type EventParticipantProfile = z.infer<
  typeof eventParticipantProfileSchema
>;

export const DEFAULT_EVENT_PARTICIPANT_PROFILE: EventParticipantProfile = {
  hostLabels: [],
  customFields: null,
} as const;
